module.exports = __webpack_public_path__ + "img/Mary_Ellen_Cosenza.f9a3d9ac.png";